export const getDefaultMembershipId = (organization?: {
  memberships?: { id?: string }[]
}): string => {
  return organization?.memberships?.[0]?.id ?? ''
}
